export default "__VITE_ASSET__ULq$2VHa__"